export class UserStatus {
  constructor(private readonly status: 'online' | 'pause' | 'offline') {}

  get isOnline(): boolean {
    return this.status === 'online';
  }
}
